export const machines = [
  {
    id: 'SakuraRoom',
    name: 'Sakura',
    description: 'Beginner-level Windows machine focusing on initial foothold.',
    image: '/Writeups/Sakura.png'
  },
  {
    id: 'BountyHackerRoom',
    name: 'Bounty Hacker',
    description: 'Intermediate Linux box with privilege escalation challenge.',
    image: '/Writeups/Bountyhunter.png'
  },
];